import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LinkPreview } from "@teammood/timeline";

@Component({
    selector: 'tm-link-preview',
    templateUrl: './linkpreview.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: []
})
export class LinkPreviewComponent {
    @Input() linkPreview: LinkPreview;

}